import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Container } from "@bw/bits"
import { Breadcrumbs } from "@bw/partials"
import { breakpoints } from "../../../theme"
import * as css from "./Pageheader.module.css"

const PageHeaderWrapper = styled.div`
  padding: calc(40px + var(--logo-offset)) 0 20px;
  color: var(--pageheader-text-color, #fff);
  background-image: var(
    --pageheader-background,
    linear-gradient(266.35deg, var(--primary) -0.23%, var(--primary-dark) 100%)
  );
  text-shadow: var(--pageheader-text-shadow, 5px 5px 20px rgba(0, 0, 0, 0.3));
  width: 100%;

  @media (min-width: ${breakpoints.small}px) {
    padding: calc(85px + var(--logo-offset)) 0 20px;
    min-height: 293px;
  }
`

const StyledHeading = styled.div`
  line-height: 1.2;
`

const Suptitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0.2em;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 20px;
  }

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 22px;
    line-height: 26px;
  }
`

const Title = styled.h1`
  margin: 0 0 0.4em;
  font-weight: 700;
  font-size: 27px;
  font-weight: 700;
  line-height: 1.1;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 35px;
  }

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 45px;
  }
`

const Subtitle = styled.div`
  line-height: 1.7;
  font-size: 16px;
  max-width: 500px;

  @media (min-width: ${breakpoints.small}px) {
    font-size: 18px;
  }
`

const AsideGrid = styled.div`
  display: flex;
  flex-direction: row;
`

const Aside = styled.div`
  margin: 0 15px 0 0;

  @media (min-width: ${breakpoints.small}px) {
    margin: 0 35px 0 0;
  }

  @media (max-width: ${breakpoints.small - 1}px) {
    .portrait {
      width: 40px;
      height: 40px;
    }
  }
`

const Buttons = styled.div`
  max-width: 100%;
  margin: 20px 0 0 -10px;

  > * {
    margin: 10px 10px 0;
    font-size: 15px;
    min-width: var(--header-button-min-width, 165px);
  }
`

const PageHeader = ({
  portrait,
  title,
  suptitle,
  subtitle,
  buttons,
  containerSize,
  breadcrumbs,
}) => {
  return (
    <PageHeaderWrapper className="pageheader">
      <Container size={containerSize} className="pageheader__container">
        <AsideGrid className="pageheader__grid">
          {portrait && <Aside>{portrait}</Aside>}
          <div className={`${css.body} pageheader__body`}>
            <StyledHeading className={`pageheader__title`}>
              {suptitle && (
                <Suptitle className={`pageheader__suptitle`}>
                  {suptitle}
                </Suptitle>
              )}
              <Title className={`pageheader__maintitle`}>{title}</Title>
              {subtitle && (
                <Subtitle className={`pageheader__subtitle`}>
                  {subtitle}
                </Subtitle>
              )}
              {buttons.length > 0 && (
                <Buttons className={`pageheader__buttons`}>{buttons}</Buttons>
              )}
            </StyledHeading>
            {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
          </div>
        </AsideGrid>
      </Container>
    </PageHeaderWrapper>
  )
}

PageHeader.propTypes = {
  portrait: PropTypes.element,
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.any,
  buttons: PropTypes.arrayOf(PropTypes.element),
  containerSize: PropTypes.oneOf(["small", "medium", "large"]),
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}

PageHeader.defaultProps = {
  containerSize: "medium",
  buttons: [],
}

export { PageHeader }
